export function track(name, properties = {}) {
  var request = new XMLHttpRequest();

  request.open('POST', '/events')

  request.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
  request.setRequestHeader("Content-type", "application/json");
  request.send(JSON.stringify({name: name, properties: properties}));
}
